import HeaderProps from "./_header-props";
import HeaderShared from "./_header-shared";

class HeaderButtonColors {
    setup() {
        this.listenForOpenAndCloseEvents();
    }

    listenForOpenAndCloseEvents() {
        const $transitionLists = HeaderProps.$header.querySelectorAll(
            "[data-list-transition]",
        );

        $transitionLists.forEach(($list) => {
            // skip search-nav and root-nav for this
            if ($list.id === "search-nav" || $list.id === "root-nav") {
                return;
            }

            // get all the sibling lists
            let $siblingLists = HeaderShared.getSiblingLists($list);

            // exclude search-nav from the sibling lists
            $siblingLists = $siblingLists.filter(($sibling) => {
                return $sibling.id !== "search-nav";
            });

            // the toggles of the sections are not inside their corresponding lists.
            // change the $sibling of sections to the container element of both the section and the toggle
            $siblingLists =
                HeaderShared.transformListSoSectionListsAreGroupedWithTheirToggles(
                    $siblingLists,
                );

            const $headerList =
                HeaderShared.transformListSoSectionListsAreGroupedWithTheirToggles([
                    $list,
                ])[0];

            // listen for list open
            $list.addEventListener("list-open", (_) => {
                this.markListAsOpen($headerList);
                this.markSiblingListsAsClosed($siblingLists, $headerList);
                this.markHeaderTogglesWithoutTargetAsVisuallyClosed();
            });

            // listen for list close
            $list.addEventListener("list-closed", (_) => {
                this.markListAsClosed($headerList);

                // wait for all the other eventlisteners on this list to finish,
                // to determine if all sibling lists are closed
                requestAnimationFrame(() => {
                    if (this.allSiblingListsAreClosed($siblingLists)) {
                        // if all lists are closed, then mark them as neutral
                        this.markSiblingListsAsNeutral($siblingLists);
                    }
                    if (this.allSiblingListsAreClosed($siblingLists, true)) {
                        this.markHeaderTogglesWithoutTargetAsNeutral();
                    } else {
                        this.markHeaderTogglesWithoutTargetAsVisuallyClosed();
                    }
                });
            });
        });
    }

    _getHeaderTogglesWithoutATarget() {
        const $allHeaderToggles = HeaderProps.$header.querySelectorAll(
            "[data-header-toggle]",
        );
        return [...$allHeaderToggles].filter(
            ($toggle) => !$toggle.dataset.headerToggle,
        );
    }

    markHeaderTogglesWithoutTargetAsVisuallyClosed() {
        const $toggles = this._getHeaderTogglesWithoutATarget();
        $toggles.forEach(($el) => {
            const $button = $el.querySelector("button, a");
            $button?.classList.add("c-button--greyed");
        });
    }

    markHeaderTogglesWithoutTargetAsNeutral() {
        const $toggles = this._getHeaderTogglesWithoutATarget();
        $toggles.forEach(($el) => {
            const $button = $el.querySelector("button, a");
            $button?.classList.remove("c-button--greyed");
        });
    }

    markAllListsAsNeutral() {
        HeaderProps.$header.querySelectorAll(".c-header__list").forEach(($list) => {
            this.markListAsNeutral($list);
        });
    }

    setVisualStateOfDesktopToggles(touchedToggleName, stateOfTargetMenu) {
        const greyedClass = "c-button--greyed";
        const $headerNavbar = HeaderProps.$header.querySelector(
            "[data-header-navbar]",
        );
        if (!$headerNavbar) {
            console.warn(
                "headerNavbar not found, sibling buttons will not be greyed out",
            );
            return;
        }
        const $headerToggles = $headerNavbar.querySelectorAll("button, a");

        if (stateOfTargetMenu !== "open") {
            $headerToggles.forEach(($toggle) =>
                $toggle.classList.remove(greyedClass),
            );
            return;
        }

        $headerToggles.forEach(($toggle) => {
            if (
                $toggle.innerHTML
                    .toLowerCase()
                    .includes(touchedToggleName.replace(/-nav/, ""))
            ) {
                $toggle.classList.remove(greyedClass);
                return;
            }
            $toggle.classList.add(greyedClass);
        });
    }

    markSiblingListsAsClosed($siblings, $except) {
        if (
            HeaderShared.parentIsRootNav($except) &&
            $except.hasAttribute("data-list-transition")
        ) {
            $except = $except.parentElement;
        }
        $siblings.forEach(($sibling) => {
            if ($sibling !== $except) {
                this.markListAsClosed($sibling);
            }
        });
    }

    markSiblingListsAsNeutral($siblings) {
        $siblings.forEach(($sibling) => {
            this.markListAsNeutral($sibling);
        });
    }

    allSiblingListsAreClosed($siblings, topLevelOnly = false) {
        if (topLevelOnly) {
            const $headerSiblings = $siblings.filter(($el) => {
                return !!$el.querySelector(
                    ".c-header__toggle-section:not(.c-header__toggle-section + * .c-header__toggle-subsection)",
                );
            });

            const hasOpenSiblings = $headerSiblings.filter(($el) => {
                return !!$el.classList.contains("c-header__list--open");
            });
            return !hasOpenSiblings.length;
        }
        return $siblings.every(($sibling) => {
            return $sibling.classList.contains("c-header__list--closed");
        });
    }

    markListAsOpen($headerList) {
        $headerList.classList.add("c-header__list--open");
        $headerList.classList.remove("c-header__list--closed");
    }

    markListAsClosed($headerList) {
        $headerList.classList.add("c-header__list--closed");
        $headerList.classList.remove("c-header__list--open");
    }

    markListAsNeutral($headerList) {
        $headerList.classList.remove("c-header__list--open");
        $headerList.classList.remove("c-header__list--closed");
    }
}

export default new HeaderButtonColors();
